import React, {useState, useEffect} from 'react'
import botImg from '../img/bot_helper.png';
import { addProjectFirestore, getDataFromFirestore } from '../firebaseService';
import Loader from './Loader';

function FinishProject({user, data, id}) {
  const [loading, setLoading] = useState(false);
  const [countProjectUser, setCountProjectUser] = useState(0);

const text = `Дорогий ${user}

Вітаємо тебе з величезним досягненням — створенням твоєї ${countProjectUser} бізнес-моделі Lean Canvas! Це неймовірно важливий крок у світі підприємництва, який відкриває перед тобою нові горизонти. Ти вже демонструєш лідерські якості, креативність та готовність змінювати світ на краще.

Твоя ідея в сфері соціального підприємництва — це більше, ніж просто проект. Це реальний внесок у розвиток громади, відповідальність за зміни та можливість зробити щось значуще. Працюючи над Lean Canvas, ти здобув(ла) цінний досвід аналізу проблем, пошуку рішень, визначення цільової аудиторії та створення цінності для суспільства.

Бажаємо тобі натхнення, віри в себе та нових звершень! Хай ця бізнес-модель стане першою сходинкою на шляху до великих досягнень, а твоя праця мотивує інших до дій.

Твої ідеї — це справжній скарб, який допомагає будувати краще майбутнє! 🚀

З найкращими побажаннями,
Платформа соціального шкільного підприємництва SocialLeanHub`
useEffect(() => {
  setLoading(true);
  getDataFromFirestore().then((fetchedData) => {
    const userProjectsCount = fetchedData.filter((p) => p.user === user).length;
    setCountProjectUser(userProjectsCount); 
  });
  setLoading(false);
}, [user]);
useEffect ( ()=> {

  const newProject = {
    user,
    id: id,
    data: data
}
setLoading(true);
const  addProj = async () =>{
 await addProjectFirestore(newProject)
}
addProj();
setLoading(false);



}, [])

  return loading ? <Loader/>: (
    <div className="text-container">
    <img src={botImg} alt="bot-kozak for help young people" />
    <div className="text-frame">
      <p className="animated-text">{text}</p>
    </div>
    </div>
  )
}

export default FinishProject
